import { useQuery } from '@apollo/client';
import { Box, Heading, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { GetUserQueryGQLType } from 'types/dashboard-core-gqlTypes.generated.d';

import {
  dashboardRoutePadding,
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { SettingsUserContainer } from 'packages/user/ui/SettingsUserContainer';
import { GET_USER } from 'requests/queries.gql';

import 'source/borrower/borrower.scss';

export const SettingsUserRoute = () => {
  const toast = useToast();
  const history = useHistory();
  const {
    data: userData,
    loading: userLoading,
  } = useQuery<GetUserQueryGQLType>(GET_USER);
  if (userLoading || !userData || !userData.user) {
    return <Skeleton height="600px" data-testid="settings-route-loading" />;
  }
  const { user } = userData;

  let routeLevelError = false;
  return (
    <Box padding={dashboardRoutePadding}>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load settings page`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <Heading as="h2" mb="60px">
          Settings
        </Heading>
        <SettingsUserContainer user={user} />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
